export default "__VITE_ASSET__DmNKLz6e__"